

























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import { Dictionary } from "vue-router/types/router";

class PageSwitchDetailRequest {
  switchId: string;
  startTime: string;
  endTime: string;
  page: number;
  pageSize: number;
  sortBy: string;
  descending: boolean;
  filterFileds: any;
}
@Component({
  components: {},
})
export default class SwitchDetail extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "" }) detailId: string;
  pagerequest: PageSwitchDetailRequest = new PageSwitchDetailRequest();
  customerlist: any[] = [];
  create() { }
  created() {
    this.pagerequest.startTime = Moment()
      .add(-7, "days")
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
  }
  changdate(val) {
    if (val.length > 1) {
      this.pagerequest.startTime = val[0];
      this.pagerequest.endTime = Moment(val[1], "YYYY-MM-DD HH:mm:ss")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
  }
  get list() {
    return this.$store.state.switchrecord.list;
  }
  cancel() {
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
    this.pagerequest.sortBy = "readTime";
    this.pagerequest.descending = true;
    this.getpage();
  }
  data() {
    return {
      arealist: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
    };
  }
  pageChange(page: number) {
    this.$store.commit("switchrecord/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("switchrecord/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    console.log(key);
    if (key.order === "desc" || key.order === "normal") {
      //this.pagerequest.sortBy = key.key + " " + key.order;
      this.pagerequest.sortBy = key.key;
      this.pagerequest.descending = true;
    } else {
      this.pagerequest.sortBy = key.key;
      this.pagerequest.descending = false;
    }
    this.getpage();
  }
  async getpage() {
    this.pagerequest.pageSize = this.pageSize;
    this.pagerequest.page = this.currentPage;
    console.log(this.pagerequest);
    await this.$store.dispatch({
      type: "switchrecord/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.switchrecord.pageSize;
  }
  get totalCount() {
    return this.$store.state.switchrecord.totalCount;
  }
  get currentPage() {
    return this.$store.state.switchrecord.currentPage;
  }
  get loading() {
    return this.$store.state.switchrecord.loading;
  }
  //列名
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      title: this.L("DeviceNo"),
      key: "deviceNo",
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.deviceNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      title: this.L("RoomNo"),
      key: "roomNo",
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.roomNo,
            },
          },
          params.row.roomNo
        );
      },
    },
    {
      title: this.L("Location"),
      key: "location",
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("LastReportTime"),
      key: "reportTime",
      sortable: true,
      sortType: "desc",
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.reportTime == null
            ? ""
            : Moment(params.row.reportTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("CSQ"),
      key: "signal",
      width: 130,
    },
    {
      title: this.L("OnOffState"),
      key: "onOffState",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.onOffState == true ? this.L("Open") : this.L("Close")
        );
      },
    },
  ];
  @Watch("detailId", { deep: true })
  getitemId() {
    this.pagerequest.switchId = this.detailId;
  }
}
